
import { getUserList, deleteUser } from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getOptionList, optionKey } from "@/api/api-dict";
import addUser from "./components/add-user.vue";
import resetPassword from "./components/reset-password.vue";
import { State } from "vuex-class";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-add-user": addUser,
    "pi-reset-password": resetPassword
  }
})
export default class SystemConfigUser extends Vue {
  @State("sys") sys!: objAny;
  private privilege: objAny = {};
  private addUserElement: objAny = {};
  private selectList: object[] = [];
  private roleTypeList: object[] = [];
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    globalOrderBy: "",
    roleType: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: ""
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: i18n.t("user.userName"),
      key: "userName",
      minWidth: 100,
      sortable: true
    },
    {
      title: i18n.t("user.fullName"),
      key: "fullName",
      sortable: true,
      minWidth: 100
    },
    {
      title: i18n.t("user.phone"),
      key: "phone",
      minWidth: 120
    },
    {
      title: i18n.t("role.roleName"),
      key: "roleName",
      minWidth: 100
    },
    {
      title: i18n.t("role.roleType"),
      key: "roleTypeDesc",
      minWidth: 100
    },
    {
      title: i18n.t("user.objectName"),
      key: "objectName",
      slot: "user",
      minWidth: 100
    },
    {
      title: i18n.t("role.createUserName"),
      key: "creator",
      minWidth: 100,
      sortable: true
    },
    {
      title: i18n.t("role.createTime"),
      key: "createTime",
      minWidth: 160,
      sortable: true
    },
    {
      title: i18n.t("operation"),
      width: 120,
      slot: "action"
    }
  ];
  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrderBy = "";
    } else {
      this.formInline.globalOrderBy =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }

  public addUser(): void {
    this.addUserElement.open({}, "add");
  }
  public queryItem(item: objAny): void {
    this.addUserElement.open(item, "query");
  }
  public updataItem(item: objAny): void {
    this.addUserElement.open(item, "updata");
  }
  public resetPassword(item: objAny): void {
    const resetPassword: objAny = this.$refs.resetPassword;
    resetPassword.open(item);
  }
  public selectItem(list: object[]) {
    this.selectList = list;
  }
  public delMoreUser() {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("user.delUserConfirm") + "",
      onOk: () => {
        if (this.selectList.length > 0) {
          const arr: objAny = [];
          this.selectList.map((item: objAny) => {
            arr.push(item.userPkId);
          });
          this.alldDelitem(arr);
        }
      }
    });
  }
  public delItem(item: objAny): void {
    this.alldDelitem([item.userPkId]);
  }
  public getChild(child: objAny) {
    this.addUserElement = child;
  }

  async alldDelitem(userArr: objAny): Promise<void> {
    const ret = await deleteUser({ userPkIds: userArr });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const json = JSON.parse(JSON.stringify(this.formInline));
    // if (!json.roleType) {
    //   json.roleType = null;
    // }
    const ret = await getUserList(json);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  async getOptionList(): Promise<void> {
    const ret = await getOptionList([optionKey.roleTypeObj]);
    this.roleTypeList = ret[optionKey.roleTypeObj];
  }

  mounted() {
    this.privilege = this.$route.meta.privilegeVoObj;
    this.getOptionList();
    this.getTableList();
  }
  activated() {
    const query = this.$route.query;
    if (query.globalSearch) {
      this.formInline.globalSearch = query.globalSearch;
    }
    this.queryClick();
  }
}
